import firebase from "firebase";
import { firebaseConfig } from "../config/firebase";

/**
 * configの設定を利用してfirebaseを使う
 */
export default firebase.initializeApp(firebaseConfig);